






































import { RateChangesState } from "@/models";
import ChangeFilters from "@/views/rate-changes/components/ChangeFilters.vue";
import GeneralInfo from "@/views/rate-changes/components/GeneralInfo.vue";
import RateChangeTable from "@/views/rate-changes/components/RateChangeTable.vue";
import FiltersApplied from "@/views/rate-changes/components/FiltersApplied.vue";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  name: "SelectTenants",
  components: { FiltersApplied, RateChangeTable, GeneralInfo, ChangeFilters }
})
export default class SelectChange extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;

  // ===== Props ===== //

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
}
